import { AutomationViewActionsListCard } from 'client/components/core/Sidebar/components/Settings/components/AutomationRulesSettings/automation-view-actions-list-card'
import {
  AutomationRuleActionsEnum,
  AutomationRuleActionsTitleEnum,
} from 'client/enums/AutomationRulesEnum'
import { ActionSaveType } from 'client/types/AutomationRulesActionsEditInterface'
import { AutomationRulesActionsType } from 'client/types/AutomationRulesActionsInterface'
import { localeNames } from 'common/constants/localeTypes'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { OptionWrapper } from 'src/editor/layout/sidebar/settings/option-wrapper'
import { getActionIcon } from './utils/get-rule-icon'

interface AutomationActionsListProps {
  actions: (AutomationRulesActionsType | ActionSaveType)[]
}

function AutomationActionsList({ actions }: AutomationActionsListProps) {
  const { t } = useTranslation()

  return (
    <OptionWrapper
      labelText="entity_settings.automation_rule.automations"
      itemStyles={{ marginBottom: '15px' }}
    >
      <div className="flex flex-col gap-3">
        {actions.map(action => {
          switch (action.type) {
            case AutomationRuleActionsEnum.add_tag:
              return (
                <AutomationViewActionsListCard
                  key={`${action.type} - ${action.id || action.tag.id}`}
                  icon={getActionIcon(action.type)}
                  title={t(AutomationRuleActionsTitleEnum[action.type])}
                  subtitle={action.tag.name}
                />
              )
            case AutomationRuleActionsEnum.remove_tag:
              return (
                <AutomationViewActionsListCard
                  key={`${action.type} - ${action.id || action.tag.id}`}
                  icon={getActionIcon(action.type)}
                  title={t(AutomationRuleActionsTitleEnum[action.type])}
                  subtitle={action.tag.name}
                />
              )
            case AutomationRuleActionsEnum.subscribe_to_campaign:
              return (
                <AutomationViewActionsListCard
                  key={`${action.type} - ${action.id || action.campaign.id}`}
                  icon={getActionIcon(action.type)}
                  title={t(AutomationRuleActionsTitleEnum[action.type])}
                  subtitle={action.campaign.name}
                />
              )
            case AutomationRuleActionsEnum.unsubscribe_from_campaign:
              return (
                <AutomationViewActionsListCard
                  key={`${action.type} - ${action.id || action.campaign.id}`}
                  icon={getActionIcon(action.type)}
                  title={t(AutomationRuleActionsTitleEnum[action.type])}
                  subtitle={action.campaign.name}
                />
              )
            case AutomationRuleActionsEnum.send_email:
              return (
                <AutomationViewActionsListCard
                  key={`${action.type} - ${action.id || action.systemeEmail.id}`}
                  icon={getActionIcon(action.type)}
                  title={t(AutomationRuleActionsTitleEnum[action.type])}
                  subtitle={action.systemeEmail.subject}
                />
              )
            case AutomationRuleActionsEnum.send_email_to_specific_address:
              return (
                <AutomationViewActionsListCard
                  key={`${action.type} - ${action.id || action.emailMessageWithRecipient.id}`}
                  icon={getActionIcon(action.type)}
                  title={t(AutomationRuleActionsTitleEnum[action.type])}
                  subtitle={
                    action?.emailMessageWithRecipient?.mailing?.currentEmail
                      ?.subject
                  }
                />
              )
            case AutomationRuleActionsEnum.enroll_in_course:
              return (
                <AutomationViewActionsListCard
                  key={`${action.type} - ${action.id || action.course.id}`}
                  icon={getActionIcon(action.type)}
                  title={t(AutomationRuleActionsTitleEnum[action.type])}
                  subtitle={action.course.name}
                />
              )
            case AutomationRuleActionsEnum.revoke_access_to_course:
              return (
                <AutomationViewActionsListCard
                  key={`${action.type} - ${action.id || action.course.id}`}
                  icon={getActionIcon(action.type)}
                  title={t(AutomationRuleActionsTitleEnum[action.type])}
                  subtitle={action.course.name}
                />
              )
            case AutomationRuleActionsEnum.revoke_access_to_course_bundle:
              return (
                <AutomationViewActionsListCard
                  key={`${action.type} - ${action.id || action.courseBundle?.id}`}
                  icon={getActionIcon(action.type)}
                  title={t(AutomationRuleActionsTitleEnum[action.type])}
                  subtitle={action.courseBundle?.name}
                />
              )
            case AutomationRuleActionsEnum.enroll_in_course_bundle:
              return (
                <AutomationViewActionsListCard
                  key={`${action.type} - ${action.id || action.courseBundle?.id}`}
                  icon={getActionIcon(action.type)}
                  title={t(AutomationRuleActionsTitleEnum[action.type])}
                  subtitle={action.courseBundle?.name}
                />
              )
            case AutomationRuleActionsEnum.send_webhook:
              return (
                <AutomationViewActionsListCard
                  key={`${action.type} - ${action.id || action.webhookUrl}`}
                  icon={getActionIcon(action.type)}
                  title={t(AutomationRuleActionsTitleEnum[action.type])}
                  subtitle={action.webhookUrl}
                />
              )
            case AutomationRuleActionsEnum.grant_access_to_community:
              return (
                <AutomationViewActionsListCard
                  key={`${action.type} - ${action.id || action.community.id}`}
                  icon={getActionIcon(action.type)}
                  title={t(AutomationRuleActionsTitleEnum[action.type])}
                  subtitle={action.community.name}
                />
              )
            case AutomationRuleActionsEnum.revoke_access_to_community:
              return (
                <AutomationViewActionsListCard
                  key={`${action.type} - ${action.id || action.community.id}`}
                  icon={getActionIcon(action.type)}
                  title={t(AutomationRuleActionsTitleEnum[action.type])}
                  subtitle={action.community.name}
                />
              )
            case AutomationRuleActionsEnum.create_user:
              return (
                <AutomationViewActionsListCard
                  key={`${action.type} - ${action.id || action.locale}`}
                  icon={getActionIcon(action.type)}
                  title={t(AutomationRuleActionsTitleEnum[action.type])}
                  subtitle={action.locale && localeNames[action.locale]}
                />
              )
            default:
              break
          }
        })}
      </div>
    </OptionWrapper>
  )
}

export default AutomationActionsList
